import {
  AppBar,
  Dialog,
  DialogActions,
  DialogContent,
  Button,
  Icon,
  IconButton,
  Toolbar,
  Typography,
  Grow
} from '@material-ui/core';

const CustomModal = ({ open, onClose, size = 'sm', children, title, noAction, ...otherProps }) => {
  /* Props */
  const DialogProps = {
    ...otherProps,
    fullWidth: true,
    maxWidth: size,
    disableEscapeKeyDown: true,
    disableBackdropClick: true,
    TransitionComponent: Grow,
    open,
    onClose
  };

  return (
    <Dialog {...DialogProps}>
      <AppBar position="static" elevation={0}>
        {/* Title */}
        <Toolbar className="flex justify-between w-full px-16 pr-8" disableGutters>
          <Typography variant="h6" className="text-20 font-semibold" color="inherit">
            {title}
          </Typography>
          <IconButton onClick={onClose}>
            <Icon className="text-white">close</Icon>
          </IconButton>
        </Toolbar>
      </AppBar>

      {/* Content */}
      <DialogContent dividers className="p-8">
        {children}
      </DialogContent>

      {/* Action buttons */}
      {!noAction && (
        <DialogActions className="justify-between px-8 sm:px-16 p-16">
          <Button
            variant="contained"
            color="inherit"
            type="button"
            className="px-20"
            onClick={onClose}>
            Kapat
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
};

export default CustomModal;
